import { useState } from "react";
import { Layout } from "antd";
import Sidenav from "./Sidenav";
import Footer from "./Footer";
import Header from "./Header";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";

const { Header: HeaderAnt, Content, Sider } = Layout;

function Main({ children, isPartner }) {
  const [collapsed, setCollapsed] = useState(false);
  const sidenavColor = "#1890ff";

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout className="layout-dashboard">
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <Sidenav
          isPartner={isPartner}
          color={sidenavColor}
          collapsed={collapsed}
        />
      </Sider>
      <Layout className="site-layout">
        <HeaderAnt className="site-layout-background">
          {collapsed ? (
            <MenuUnfoldOutlined
              style={{ visibility: isPartner ? "hidden" : "visible" }}
              className="trigger"
              onClick={toggle}
            />
          ) : (
            <MenuFoldOutlined
              style={{ visibility: isPartner ? "hidden" : "visible" }}
              className="trigger"
              onClick={toggle}
            />
          )}
          <Header />
        </HeaderAnt>
        <Content className="content-ant">{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
}

export default Main;
